// @flow
import React, { Component } from 'react';
import { Label, FormGroup } from 'reactstrap';

import withFlightSearchParams from '../../../HOCs/withFlightSearchParams';

import api from '../../../lib/api';

import type { UpdateFlightSearchParms } from '../flowTypes';

type Props = {
  updateFlightSearchParms: UpdateFlightSearchParms,
  searchParams: {
    from_location: string,
    to_location: string,
  },
};
type Sector = {
  name: string,
  code: string,
};

type State = {
  sectors: Array<Sector>,
};

class LocationInput extends Component<Props, State> {
  state = {
    sectors: [],
  };

  render() {
    let { from_location, to_location } = this.props.searchParams;
    const { sectors } = this.state;
    return (
      <div className="row">
        <FormGroup className="col-12">
          <Label className="title">From</Label>
          <select
            className="form-control"
            onChange={this.handleInputChange}
            value={from_location}
            name="from_location"
          >
            {sectors.map(({ name, code }: Sector) => (
              <SectorOption key={code} name={name} code={code} />
            ))}
          </select>
        </FormGroup>
        <FormGroup className="  col-12">
          <Label className="title">To</Label>
          <select
            className="form-control"
            onChange={this.handleInputChange}
            value={to_location}
            name="to_location"
          >
            {sectors.map(({ name, code }: Sector) => (
              <SectorOption key={code} name={name} code={code} />
            ))}
          </select>
        </FormGroup>
      </div>
    );
  }

  componentDidMount() {
    this.getSectors();
  }

  getSectors = async () => {
    const {
      data: { sectors },
    } = await api.get('flights/sectors');

    if (sectors) this.setState({ sectors });
  };

  handleInputChange = event => {
    const { name, value } = event.target;
    const { updateFlightSearchParms } = this.props;
    updateFlightSearchParms({ parameter: name, value });
  };
}

const SectorOption = ({ name, code }: Sector) => <option value={code}>{name}</option>;

export default withFlightSearchParams(LocationInput);



// WEBPACK FOOTER //
// ./src/components/Flights/SearchInput/LocationInput.jsx